<template>
  <div>
    <div>
      <!-- 面包屑导航区域 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>出库</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="display: flex; align-items: center">
      <!-- <div
        class="deng"
        :class="{
          load: isFlag,
          end: !isFlag,
        }"
      ></div> -->
      <el-input v-model="tracking" size="mini" disabled placeholder="单号" style="width: 180px;" />
      <el-button type="primary" size="mini" plain @click="createTracking" style="margin: 0 8px">生成单号</el-button>
      <label>选择仓库:</label>
      <el-select v-model="warehouse" size="mini" placeholder="请选择仓库" style="margin: 0 8px" @change="warehousHandler">
        <el-option v-for="item in warehouseList" :key="item.warehouseName" :label="item.warehouseName"
          :value="item.warehouseName">
        </el-option>
      </el-select>
      <el-select v-model="value" size="mini" placeholder="请选择库位" style="margin: 0 8px">
        <el-option v-for="item in options" :key="item.storageLocationNO" :label="`库位${item.storageLocationNO}`"
          :value="item.storageLocationNO">
        </el-option>
      </el-select>
      <el-button type="primary" size="mini" plain :loading="isFlag" @click="outboundHandler">出库</el-button>
    </div>
    <div class="grid-28">
      <div v-for="i in options" :key="i.storageLocationNO" class="grid-item">
        <!-- <div :class="`round ${locationStatus[`warehouse${(+i.storageLocationNO)}`] === 1 ? 'true' : 'false'}`"></div> -->
        <div v-if="locationStatus[`warehouse${(+i.storageLocationNO)}`] === 1">
          <img src="../assets/pictures/tishicheng.png" class="round" alt="" srcset="" style="margin: auto;">
        </div>
        <div v-else-if="locationStatus[`warehouse${(+i.storageLocationNO)}`] === 2" style="margin: auto;">
          <img src="../assets/pictures/tishihong.png" class="round" alt="" srcset="">
        </div>
        <div v-else-if="locationStatus[`warehouse${(+i.storageLocationNO)}`] === 3" style="margin: auto;">
          <img src="../assets/pictures/tishihong.png" class="round" alt="" srcset="">
        </div>
        <div v-else>
          <img src="../assets/pictures/tishihui.png" class="round" alt="" srcset="" style="margin: auto;">
        </div>
        <div>库位{{ i.storageLocationNO }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [],
      value: "",
      isFlag: false,
      timer: null,
      locationStatus: {},
      tracking: '',
      warehouse: '',
      warehouseList: [],
    };
  },
  created() {
    this.getWarehouse()
  },
  mounted() {
    // this.init();
    // this.timer = setInterval(async () => {
    //       await this.outboundStatus();
    //     }, 2000);
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    warehousHandler(val) {
      this.warehouse = val
      this.$http.get("/WMS/selStorageLocation?WarehouseName=" + val)
        .then(({ data }) => {
          if (data.code == 200) {
            this.options = data.success_msg
            this.timer && clearInterval(this.timer)
            this.timer = setInterval(async () => {
              await this.outboundStatus()
            }, 2000)
          } else
            this.$message({
              type: "error",
              message: `库位查询失败`,
            });
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: `库位查询失败`,
          });
        })
    },
    // 获取仓库
    getWarehouse() {
      this.$http.get("/WMS/selWareHouse")
        .then(({ data }) => {
          if (data.code === 200) {
            this.warehouseList = data.success_msg
            // this.timer = setInterval(async () => {
            //   await this.outboundStatus();
            // }, 2000);
          } else
            this.$message({
              type: "error",
              message: `仓库查询失败`,
            });
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: `仓库查询失败`,
          });
        })
    },
    // 生成单号
    createTracking() {
      this.$http.get("/WMS/general_storageOut_num")
        .then(({ data }) => {
          if (data.code == 200)
            this.tracking = data.success_msg
          else
            this.$message({
              type: "error",
              message: `生成失败`,
            });
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: `生成失败`,
          });
        })
    },
    init() {
      const array = new Array(28);
      for (let i = 0; i < array.length; i++) {
        array[i] = {
          label: `库位${i + 1}`,
          value: `warehouse${i + 1}`,
          key: i + 1,
        };
      }
      this.options = array;
    },
    async outboundHandler() {
      if (!this.value) {
        this.$message({
          type: "error",
          message: `请选择仓库`,
        });
        return false
      }
      // this.timer && clearInterval(this.timer);
      this.isFlag = true
      let res;
      const params = new URLSearchParams();
      params.append("storage_location", 'warehouse' + (+this.value));
      params.append("WareHouse", this.warehouse)

      try {
        res = await this.$http.get("/WMS/redis_storage_out", { params });
      } catch (error) {
        this.isFlag = false;
        this.$message.error(res.Message);
      }

      if (res.data.code === 1) {
        this.$message.success("出库成功！")
        this.isFlag = false;
        return false;
      } else if (res.data.code === -2) {
        this.$message.error(res.data.exception_msg)
        this.isFlag = false;
      } else {
        this.$message.error(res.data.err_msg)
        this.isFlag = false;
      }
    },
    async outboundStatus() {
      let res;
      try {
        res = await this.$http.post("/WMS/redis_storage_take");
      } catch (error) {
        this.$message.error(res.Message);
      }

      if (res.data.code == 1) {
        this.locationStatus = res.data.success_msg.dataTag
        this.isFlag = false;
      }
    },
    async getLocationStatus(row) {
      try {
        const { data: res } = await this.$http.get("/WMS/queryWareHouse", {
          params: row,
        });
        if (res.code === 1) {
          this.locationStatus = res.data;
        }
      } catch (error) { }
    },
  },
};
</script>

<style lang="less" scoped>
.deng {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.load {
  background: radial-gradient(white, red);
}

.end {
  background: radial-gradient(white, black);
}


.grid-28 {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    // flex-direction: column;
    align-items: center;
    // justify-content: center;

  .grid-item {
    width: auto;
    display: inline-block;
    text-align: center;
    margin: 8px;

    .round {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .false {
      background: radial-gradient(white, black);
    }

    .true {
      background: radial-gradient(white, red);
    }

    .yellow {
      background: radial-gradient(white, yellow);
    }
  }
}
</style>
